import React from "react";

export const TableSkelton = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 9 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const TableSkelton1 = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 7 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const OtherTaskSkeleton = ({ rows = 4 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 4 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const OtherInvoiceSkeleton = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 6 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const OtherTaskSheetSkeleton = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 5 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const TableSkelton2 = ({ rows = 9 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 6 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const TableSkelton3 = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          role="status"
          className="animate-pulse border-t border-t-[#DFDFDF]"
        >
          {Array.from({ length: 7 }).map((_, colIndex) => (
            <td key={colIndex} className="py-5 px-2">
              <div className="flex justify-center items-center">
                <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const TableSkelton4 = () => {
  return (
    <tr role="status" className="animate-pulse border-t border-t-[#DFDFDF]">
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
    </tr>
  );
};

export const TableSkelton5 = () => {
  return (
    <tr role="status" className="animate-pulse border-t border-t-[#DFDFDF]">
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
      <td className="py-5 px-2">
        <div className="flex justify-center items-center">
          <div className="w-20 h-3 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
      </td>
    </tr>
  );
};
